export const APP_VERSION = '0.8.0'
export const BUILD_DATE = '2026-04-07'
